function useErrorDictionary() {
  return [
    {
      message: 'NCM already exists',
      title: 'commons.errors.generic.message',
      labelId: 'ncm.error.alreadyExists',
    },
    {
      message: 'Area already exists',
      title: 'commons.errors.generic.message',
      labelId: 'areas.error.alreadyExists',
    },
    {
      message: 'Part already exists',
      title: 'commons.errors.generic.message',
      labelId: 'parts.error.alreadyExists',
    },
    {
      message: 'Part already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'parts.error.remove.bonds',
    },
    {
      message: 'The part registered with this barcode already exists',
      title: 'commons.errors.generic.message',
      labelId: 'parts.error.barCode.alreadyExists',
    },
    {
      message: 'The part registered with this internal code already exists',
      title: 'commons.errors.generic.message',
      labelId: 'parts.error.internalCode.alreadyExists',
    },
    {
      message: 'Consumable already exists',
      title: 'commons.errors.generic.message',
      labelId: 'consumables.error.alreadyExists',
    },
    {
      message: 'Consumable already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'consumables.error.remove.bonds',
    },
    {
      message: 'Area already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'areas.error.remove.bonds',
    },
    {
      message: 'SubArea already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'areas.error.remove.bonds',
    },
    {
      message: 'Group already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'groups.error.remove.bonds',
    },
    {
      message: 'SubGroup already has a link with another entity',
      title: 'commons.errors.generic.message',
      labelId: 'groups.subGroups.error.remove.bonds',
    },
    {
      message: 'The CPF entered is incorrect',
      title: 'commons.errors.generic.message',
      labelId: 'employee.cpfIncorrect.error',
    },
    {
      message: 'Já existe um funcionário cadastrado com esse CPF',
      title: 'commons.errors.generic.message',
      labelId: 'employee.cpfAlreadyExists',
    },
    {
      message: 'Accessory already exists',
      title: 'commons.errors.generic.message',
      labelId: 'customer.vehicle.accessory.accessoryAlreadyExists',
    },
    {
      message: 'Accessory Referential integrity constraint violation',
      title: 'commons.errors.generic.message',
      labelId: 'customer.vehicle.accessory.error.delete.constraint',
    },
    {
      message:
        'ERROR: duplicate key value violates unique constraint "tb_document_type_initials_matrix_id_key"',
      title: 'commons.errors.generic.message',
      labelId: 'documentTypes.create.error.duplicate.initials',
    },
    {
      message:
        'ERROR: duplicate key value violates unique constraint "tb_document_type_description_matrix_id_key"',
      title: 'commons.errors.generic.message',
      labelId: 'documentTypes.create.error.duplicate.description',
    },
    {
      message: 'The CNPJ informed is incompatible with the registered company',
      title: 'commons.errors.generic.message',
      labelId: 'purchaseImport.error.incompatibleCompany',
    },
    {
      message: 'Recommendation already exists',
      title: 'commons.errors.generic.message',
      labelId:
        'customers.form.recommendation.create.error.duplicate.description',
    },
    {
      message: 'Recommendation Referential integrity constraint violation',
      title: 'commons.errors.generic.message',
      labelId: 'customer.recommendation.error.delete.constraint',
    },
    {
      message: 'CSOSN ICMS not informed',
      title: 'commons.errors.generic.message',
      labelId: 'itemsPurchase.error.message.csosnIcms',
    },
    {
      message: 'Company Referential integrity constraint violation',
      title: 'commons.errors.generic.message',
      labelId: 'companies.remove.error.delete.constraint',
    },
    {
      message: 'workorder.errors.workorder_item_tag_use',
      title: 'commons.errors.generic.message',
      labelId: 'companies.settings.itemTags.errors.workorder_item_tag_use',
    },
    {
      message: 'BankAccount Referential integrity constraint violation',
      title: 'commons.errors.generic.message',
      labelId: 'bankAccounts.remove.error.delete.constraint',
    },
  ];
}

export default useErrorDictionary;
